import React from 'react';
import './App.css';
import { useSelector } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.min.css';

import {
  BrowserRouter as Router,
  Route,
  Redirect,
} from "react-router-dom";
import Users from './components/Users';
import Tenants from './components/Tenants';
import TenantList from './components/TenantList';
import UserTenantConnections from './components/UserTenantConnections';
import LoginPage from './components/LoginPage';
import SideBar from './components/SideBar';
import TenantView from './components/TenantView';
import FeatureFlags from './components/FeatureFlags';
import Languages from './components/Languages';
import UserView from './components/UserView';
import Dashboard from './components/dashboard/Dashboard';
import FeatureFlagView from './components/FeatureFlagView';

function App() {
  const token = useSelector((state) => state.app.token);

  return (
    <div>
      <Router>
        {!token 
          ? <LoginPage /> 
          : <div style={{display:"flex"}}>
              <SideBar />
              <div style={{padding: "2em", flex: 1, maxHeight: "100vh", overflow: "auto"}}>
                <Route path={"/"} exact>
                  <Redirect to={"/dashboard"} />
                </Route>
                <Route path={"/login"} exact>
                  <Redirect to={"/"} />
                </Route>
                <Route path="/users" exact render={()=>{
                  return token ? 
                    <Users /> :
                    <Redirect to="/login" />
                }}/>
                <Route path="/users/:userId" render={()=>{
                  return token ? 
                    <UserView /> :
                    <Redirect to="/login" />
                }}/>
                <Route exact path="/dashboard" render={()=>{
                  return token ? 
                    <Dashboard /> :
                    <Redirect to="/login" />
                }}/>
                <Route exact path="/tenants" render={()=>{
                  return token ? 
                    <Tenants /> :
                    <Redirect to="/login" />
                }}/>
                {process.env.REACT_APP_ENVIRONMENT === 'production' && (
                  <Route exact path="/tenant-list" render={()=>{
                    return token ? 
                      <TenantList /> :
                      <Redirect to="/login" />
                  }}/>
                )}
                <Route exact path="/tenants/:id/:tab?" render={()=>{
                  return token ? 
                    <TenantView /> :
                    <Redirect to="/login" />
                }}/>
                <Route path="/user-tenant-connections" render={()=>{
                  return token ? 
                    <UserTenantConnections /> :
                    <Redirect to="/login" />
                }}/>
                <Route exact path="/feature-flags" render={()=>{
                  return token ? 
                    <FeatureFlags /> :
                    <Redirect to="/login" />
                }}/>
                <Route exact path="/feature-flags/:id/:tab?" render={()=>{
                  return token ? 
                    <FeatureFlagView /> :
                    <Redirect to="/login" />
                }}/>
                <Route exact path="/languages" render={()=>{
                  return token ? 
                    <Languages /> :
                    <Redirect to="/login" />
                }}/>
              </div>
            </div>
        }
      </Router>
    </div>
  );
}

export default App;
